// extracted by mini-css-extract-plugin
module.exports = {"howTo":"FactsPage_howTo__16WzL","cardContainer":"FactsPage_cardContainer__1qjjv","intro":"FactsPage_intro__20gkk","info":"FactsPage_info__ReIBL"};